import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [avatarOpen, setAvatarOpen] = useState(false);

  useEffect(() => {
    if (user && !user.avatar && !user.avatar_prompted) setAvatarOpen(true);
  }, [user]);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data ?? null);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await http.post("/auth/logout"); } catch { /* ignore */ }
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, setUser, loading, logout, avatarOpen, setAvatarOpen }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
